import { lazy } from 'react';
import { ComponentsMapInterface } from './types';

export enum ComponentsMapEnums {
  SALARY_MAPPING,
  PAYOUT_PROCESSING_EDGE,
  PAYOUT_PROCESSING,
  PROCESSED_PAYOUT_VIEW,
  VENDOR_PROCESSED_PAYOUT_VIEW,
  PAYOUT_PROCESSING_VIEW_INTERNAL_VENDOR,
}

export const ComponentsMap: ComponentsMapInterface = {
  SALARY_MAPPING: lazy(() => import('../pages/salary-mapping')),
  PAYOUT_PROCESSING_EDGE: lazy(
    () =>
      import(
        '../pages/payout-processing/components/EdgePayout/EdgePayoutProcessing'
      ),
  ),
  PAYOUT_PROCESSING: lazy(() => import('../pages/payout-processing')),
  PROCESSED_PAYOUT_VIEW: lazy(
    () => import('../pages/payout-processing/components/ProcessedPayoutsView'),
  ),
  VENDOR_PROCESSED_PAYOUT_VIEW: lazy(
    () =>
      import(
        '../pages/payout-processing/components/VendorPayout/VendorPayoutProcessing'
      ),
  ),
  PAYOUT_PROCESSING_VIEW_INTERNAL_VENDOR: lazy(
    () =>
      import(
        '../pages/payout-processing/components/InternalVendorPayout/PayoutProcessingInternalVendor'
      ),
  ),
};
